export default __webpack_public_path__ + "static/media/habilitar-permiso-camara-safari-1.e27d75f6.svg";